import { Container } from 'react-bootstrap';
import SideBarManager from './SideBarManager';
import { Route, Routes } from 'react-router-dom';
import Dashboard from './managerModules/Dashboard';
import Transacciones from './managerModules/Transactions';
import Movimientos from './managerModules/Movements';
import Aclaraciones from './managerModules/Clarifications';
import Facturas from './managerModules/Bills';
import Configuracion from './managerModules/setting';
import SmartLinksPage from '../smartlinks/pages/SmartLinksPage';
import LinksTableView from '../smartlinks/pages/SmartLinkList';
import LinksView from '../smartlinks/pages/LinksView';
import RecurringPayments from './managerModules/RecurringPayments/RecurringPayments';

const ManagerInt = () => {
    return (
        <div style={{ display: 'flex', height: '100vh' }}>
            <SideBarManager style={{ flex: '0 0 auto', height: '100vh' }} />

                <Container fluid className='p-0' style={{ flex: '1 1 auto', overflowY: 'auto' }}>
                    <Routes>
                        <Route path='/Inicio/*' element={<Dashboard />} />
                        <Route path='/Transacciones/*' element={<Transacciones />} />
                        <Route path='/Depositos/*' element={<Movimientos />} />
                        <Route path='/Facturas/*' element={<Facturas />} />
                        <Route path='/Aclaraciones/*' element={<Aclaraciones />} />
                        <Route path='/Smartlinks/*' element={<SmartLinksPage />} />
                        <Route path='/SmartlinksList/*' element={<LinksTableView />} />
                        <Route path='/LinksView/*' element={<LinksView />} />
                        <Route path='/RecurringPayments/*' element={<RecurringPayments />} />
                    </Routes>
                </Container>

        </div>
    );
}

export default ManagerInt;